/**
 * StatusPill
 *
 * Rounded label with a colour dot. The text carries the meaning; colour is reinforcement only.
 */
import type { StatusTone } from '../../utils/reliabilityPresentation';

interface StatusPillProps {
  readonly tone: StatusTone;
  readonly label: string;
}

export function StatusPill({ tone, label }: StatusPillProps): JSX.Element {
  return (
    <span className={`reliability-pill reliability-pill--${tone}`}>
      <span className="reliability-dot" aria-hidden="true" />
      {label}
    </span>
  );
}
